import type { HTMLAttributes } from "react";
import { cx } from "../presentation.tsx";

export interface SpinnerProps extends HTMLAttributes<HTMLSpanElement> {
  size?: "sm" | "md" | "lg";
  /** Accessible status text. Pass "" when a parent already announces the busy state. */
  label?: string;
}

export function Spinner({ size = "md", label = "Loading", className, ...rest }: SpinnerProps) {
  return (
    <span
      {...rest}
      className={cx("pmu-spinner", `pmu-spinner--${size}`, className)}
      {...(label ? { role: "status", "aria-label": label } : { "aria-hidden": true })}
    >
      <svg viewBox="0 0 24 24" focusable="false" aria-hidden="true">
        <circle cx="12" cy="12" r="9.5" fill="none" strokeWidth="3" className="pmu-spinner__track" />
        <path d="M12 2.5a9.5 9.5 0 019.5 9.5" fill="none" strokeWidth="3" strokeLinecap="round" className="pmu-spinner__arc" />
      </svg>
    </span>
  );
}
